import { storeGroup } from "@/schemas/storeGroup";

export const storeGroupFormSchema = storeGroup.omit({ id: true });
